import React from "react";

// Capa 2: columna de checks (Región / Sucursal / Departamento u otra lista).
// items: [{ id, label }] — seleccionados: [id]
// Fecha de creación: 2026-09-15 — Autor: IA (Claude)
const ListaChecksFiltro = ({ titulo, items = [], seleccionados = [], onToggle, vacio = "Sin opciones" }) => (
  <div className="filtro-checks">
    <div className="filtro-checks-titulo">{titulo}</div>
    <div className="filtro-checks-lista">
      {items.length === 0 && <span className="filtro-checks-vacio">{vacio}</span>}
      {items.map((item) => {
        const id = String(item.id);
        return (
          <label key={id} className="filtro-checks-item">
            <input
              type="checkbox"
              checked={seleccionados.includes(id)}
              onChange={() => onToggle(id)}
            />
            <span>{item.label}</span>
          </label>
        );
      })}
    </div>
  </div>
);

export default ListaChecksFiltro;
